// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"elevated-box__wrap--GTwSx","clickable":"elevated-box__clickable--IDSxD"};